module.exports = __webpack_public_path__ + "static/media/step5.a19704c6.svg";